import { DataType } from '@/util/index'
const ACTION = DataType.PaymentScheduleAction
const SINGLE_PAYMENT_SCHEDULE_ACTION = {
  ASSIGNED_AMOUNT: {
    title: ACTION.ASSIGNED_AMOUNT.text,
    value: ACTION.ASSIGNED_AMOUNT.value,
    privilegeCode: DataType.PrivilegeCode.ASSIGNED_AMOUNT,
    limitValue: true,
    fieldClass: 'lg12',
    fields: [
      { label: 'Principal', fieldKey: 'principal', template: '{principal}', format: 'currency', controlType: 'checkbox-input' },
      { label: 'Interest', fieldKey: 'interest', template: '{interest}', format: 'currency', controlType: 'checkbox-input' },
      { label: 'Unpaid Fee', fieldKey: 'unpaidFee', template: '{unpaidFee}', format: 'currency', controlType: 'checkbox-input' },
      { label: 'NSF Fee', fieldKey: 'nsfFee', template: '{nsfFee}', format: 'currency', controlType: 'checkbox-input' },
      { label: 'Late Fee', fieldKey: 'lateFee', template: '{lateFee}', format: 'currency', controlType: 'checkbox-input' }
    ]
  },
  REFUND_PAYMENT: {
    title: ACTION.REFUND_PAYMENT.text,
    value: ACTION.REFUND_PAYMENT.value,
    privilegeCode: DataType.PrivilegeCode.REFUND_PAYMENT,
    limitValue: true,
    fieldClass: 'lg12',
    fields: [
      { label: 'Max Refund Fee', fieldKey: 'amount', template: '{amount}', format: 'currency', controlType: 'spanWithText' },
      { label: 'Max Bank Fee', fieldKey: 'maxPartialBankFee', template: '{maxPartialBankFee}', format: 'currency', controlType: 'spanWithText' },
      { label: 'Disbursement Date', fieldKey: 'transactionDate', template: '{transactionDate}', allowed: 'start-tomorrow no-holiday no-weekend', moreDate: true },
      { label: 'Refund Fee', fieldKey: 'refundFee', template: '{refundFee}', format: 'currency' },
      { label: 'Bank Fee', fieldKey: 'bankFee', template: '{bankFee}', format: 'currency', couldEmpty: true }
    ]
  },
  CANCEL_CHANGE: {
    title: ACTION.COLLECTION_SINGLE_CANCEL.text,
    value: ACTION.COLLECTION_SINGLE_CANCEL.value,
    privilegeCode: DataType.PrivilegeCode.CANCEL,
    fieldClass: 'lg12',
    fields: []
  }
}
export default SINGLE_PAYMENT_SCHEDULE_ACTION
